import { ApiAccountHistoryReport } from 'api/rtk-api'

export const getFormattedChartData = (data: ApiAccountHistoryReport) => {
  const { targetWeights } = data.account.portfolio
  const formattedData = targetWeights.reduce(
    (formattedData, currentTargetWeight) => {
      const { asset, weight } = currentTargetWeight

      if (asset.taxClassification === 'Capital')
        formattedData.taxClassification[0].value += weight * 100
      if (asset.taxClassification === 'Yield')
        formattedData.taxClassification[1].value += weight * 100

      const existingAssetClass = formattedData.assetClass.find(
        assetClass => assetClass.name === asset.assetClass
      )
      if (existingAssetClass) {
        existingAssetClass.value += weight * 100
      } else {
        formattedData.assetClass.push({
          parent: '0',
          name: asset.assetClass,
          id: asset.assetClass,
          value: weight * 100
        })
      }

      const existingCurrency = formattedData.currency.find(
        currency => currency.name === asset.currencyIso
      )
      if (existingCurrency) {
        existingCurrency.value += weight * 100
      } else {
        formattedData.currency.push({
          parent: '0',
          name: asset.currencyIso,
          id: asset.currencyIso,
          value: weight * 100
        })
      }

      const existingFrequency = formattedData.tradingFrequency.find(
        frequency => frequency.name === asset.dealingFrequency
      )
      if (existingFrequency) {
        existingFrequency.value += weight * 100
      } else {
        formattedData.tradingFrequency.push({
          parent: '0',
          name: asset.dealingFrequency,
          id: asset.dealingFrequency,
          value: weight * 100
        })
      }

      return formattedData
    },
    {
      taxClassification: [
        {
          parent: '0',
          name: 'Capital',
          id: 'capital',
          value: 0
        },
        {
          parent: '0',
          name: 'Yield',
          id: 'yield',
          value: 0
        }
      ],
      assetClass: [],
      currency: [],
      tradingFrequency: []
    }
  )

  return formattedData
}
